import { useContext, useEffect } from "react";
import { useLocation } from "react-router";
import { getPartnerName } from "@/utils/partners/getPartnerName";
import { getPageNameFromPath } from "@/utils/pages/getPageNameFromPath";
import { useTextDomainContext } from "@/app/providers";

/**
 * Custom hook to set dynamic page title based on page name and partner
 * @param {string|null} pageName - The name of the current page (optional - will auto-detect from route if not provided)
 * @param {boolean} includePartner - Whether to include partner name (default: true)
 */
export const usePageTitle = (
  pageName: string | null = null,
  includePartner: boolean = true,
) => {
  const location = useLocation();
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  useEffect(() => {
    const finalPageName =
      pageName || getPageNameFromPath(location.pathname, gettext);

    if (finalPageName) {
      const partnerName = includePartner ? getPartnerName() : null;
      const title = partnerName
        ? `${finalPageName} | ${partnerName}`
        : finalPageName;
      document.title = title;
    }
  }, [pageName, includePartner, location.pathname, gettext]);
};
